<template>
  <b-row>
    <b-col>
      <b-card :class="{ open: visibleBody }" style="margin:0">
        <b-card-header
          :class="{ collapsed: !visibleBody }"
          role="tab"
          @click="onVisibleBody()"
          style="background-color: #0080C9; color: white; font:45px; padding: 15px; cursor: pointer;"
        >
          <span class="lead collapse-title"><strong>IMAGENES</strong></span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >

          <b-card-body style="margin:0; border:1px solid #2980b9;">

            <!-- <span>{{'tokenAtencion ' + tokenAtencion }}</span> -->

            <div 
              class="row d-flex align-items-center mt-1" 
              style="position: relative;"
            >
              <CommentEditor
                v-if="isAuditoria"
                field="imagenes"
                :comentarios="comentarios"
              />
            </div>

            <ImagenesList
              onlyView
              v-if="imagenes && imagenes.length"
              v-model="imagenes"
            />

            <EmptyResults 
              v-if="!imagenes || imagenes.length === 0"
              :message="'No se encontraron imágenes para mostrar.'"
            />
          </b-card-body>

        </b-collapse>
      </b-card>
    </b-col>

  </b-row>
</template>

<script>
import { EmptyResults }    from '@/shared/components';
import { imagenesService } from '@/views/imagen/services';
import { ImagenesList }    from '@/views/imagen/components';

import CommentEditor from '../CommentEditor/CommentEditor.vue';

export default {
  name: "AtencionImagenes",

  props: {
    tokenAtencion: {
      type: String,
      required: true
    },

    isAuditoria: {
      type: Boolean,
      required: false
    }
  },

  components: {
    EmptyResults,
    ImagenesList,
    CommentEditor
  },

  data() {
    return {
      visibleBody: false,
      imagenes: null,

      comentarios:{},
    };
  },


  created() {
    this.onGetData();
  },

  methods: {
    onVisibleBody() {
      this.visibleBody = !this.visibleBody
    },

    async onGetData(){
      const data = await imagenesService.getByAtencion(this.tokenAtencion);
      console.log('las imagenes', data);

      if(!data) return;
      this.imagenes = data;
      
    }
  },

  watch: {

    comentarios:{
      deep: true,
      handler(newValue) {
        const comentario = newValue.imagenes
        this.$store.commit("setComentarios", { imagenes: comentario });

        this.$store.commit("setRevisiones", {
          tokenAtencion: this.tokenAtencion,
          data: { imagenes: comentario }
        });
      }
    }
  }
}
</script>
